import React, { useState, useEffect } from 'react';
import { Calendar, BadgeCheck, Loader2 } from 'lucide-react';
import axios from '../lib/axios';
import { API } from '../App';

const SellerPerformance = ({ userId, compact = false }) => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userId) {
      fetchMetrics();
    }
  }, [userId]);

  const fetchMetrics = async () => {
    try {
      const response = await axios.get(`${API}/users/${userId}/performance`);
      setMetrics(response.data);
    } catch (error) {
      console.error('Failed to fetch seller metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-2">
        <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!metrics) return null;

  const memberYear = new Date(metrics.member_since).getFullYear();

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-secondary text-muted-foreground text-xs rounded-full" data-testid="seller-performance-compact">
        <Calendar className="w-3 h-3" />
        Since {memberYear}
      </span>
    );
  }

  return (
    <div className="flex items-center justify-between text-sm" data-testid="seller-performance">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Calendar className="w-4 h-4" />
        <span>Seller since {memberYear}</span>
      </div>
      
      {metrics.is_verified && (
        <div className="flex items-center gap-1 text-blue-500">
          <BadgeCheck className="w-4 h-4" />
          <span className="text-xs font-medium">Verified</span>
        </div>
      )}
    </div>
  );
};

export default SellerPerformance;
